// components/LoginPage.jsx
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    TextField,
    Button,
    Typography,
    Box,
    Alert,
    Divider
} from '@mui/material';

export default function LoginPage() {
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { loginWithEmail, loginWithGoogle, defaultProtectedPath } = useAuth();
    const navigate = useNavigate();
    const from = location.state?.from || defaultProtectedPath || '/';
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setError('');
            setLoading(true);
            await loginWithEmail(email, password);
            navigate(from, { replace: true });  // Redirect back to requested page
        } catch (err) {
            setError('Failed to log in: ' + err.message);
        }
        setLoading(false);
    };

    const handleGoogleLogin = async () => {
        try {
            setError('');
            setLoading(true);
            await loginWithGoogle();
            navigate('/lesson');
        } catch (err) {
            setError('Google login failed: ' + err.message);
        }
        setLoading(false);
    };

    return (
        <Box sx={{
            maxWidth: 460,
            mx: 'auto',
            mt: { xs: 3, md: 6 },
            p: { xs: 3, md: 4 },
            backgroundColor: 'background.paper',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 18px 40px rgba(15, 23, 42, 0.06)',
        }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 1 }}>
                Log in
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Continue into your learning workspace.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    margin="normal"
                    required
                />

                <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    margin="normal"
                    required
                />

                <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{ mt: 2 }}
                >
                    {loading ? 'Logging in...' : 'Login'}
                </Button>
            </Box>

            <Divider sx={{ my: 3 }}>OR</Divider>

            <Button
                fullWidth
                variant="outlined"
                onClick={handleGoogleLogin}
                disabled={loading}
            >
                Continue with Google
            </Button>

            <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    New registrations are temporarily disabled.
                </Typography>
            </Box>
        </Box>
    );
}
